export default "__VITE_ASSET__5d48b194__"